import CustomTraceabilityList from '../../components/CustomTraceabilityList';

const TraceabilityList = () => {
  return <CustomTraceabilityList normative="coe" />;
};

export default TraceabilityList;
